module.exports = __webpack_public_path__ + "static/sign-up-form-26aee9c076f07927460d6bbde0266944.png";